import { useFormContext } from "react-hook-form";
import { hotelTypes } from "../../config/hotel-options-config";
import { HotelFormData } from "./ManageHotelForm";

const TypeSection = () => {
  const {
    register,
    watch,
    formState: { errors },
    setValue,
  } = useFormContext<HotelFormData>();

  const typeWatch = watch("type") || []; // Watch for the type, default to an empty array

  const handleCheckboxChange = (type: string) => {
    const updatedTypes = typeWatch.includes(type)
      ? typeWatch.filter((selectedType: string) => selectedType !== type)
      : [...typeWatch, type];

    setValue("type", updatedTypes); // Update the form value with the new array
  };

  return (
    <div className="p-4 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-center uppercase">Type</h2>
      <hr className="border-gray-200 w-10/12 mx-auto mb-10" />
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {hotelTypes.map((type) => (
          <label
            key={type}
            className={`cursor-pointer flex items-center justify-center rounded-md px-4 py-2 font-semibold transition-colors ${
              typeWatch.includes(type)
                ? "bg-halo-pink text-white border-2 border-halo-pink"
                : "bg-gray-100 text-gray-700 border border-gray-200"
            } hover:bg-halo-pink hover:text-white hover:border-none`}
          >
            <input
              type="checkbox"
              value={type}
              {...register("type", {
                required: "Please select at least one type",
              })}
              onChange={() => handleCheckboxChange(type)} // Handle checkbox change
              className="hidden"
            />
            <span>{type}</span>
          </label>
        ))}
      </div>
      {errors.type && (
        <span className="text-red-500 text-sm font-bold mt-2 block">
          {errors.type.message}
        </span>
      )}
    </div>
  );
};

export default TypeSection;
